import React from 'react';

/** Section heading + responsive grid wrapper for a group of Fields inside a Dialog. */
export function FieldSection({ title, children, className = '' }) {
  return (
    <div className={`mb-6 last:mb-0 ${className}`}>
      <h3 className="mb-3 text-xs font-bold uppercase tracking-wide text-brand-600">{title}</h3>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">{children}</div>
    </div>
  );
}

/** Read-only "label above value" display used in detail/review dialogs. */
export function Field({ label, value, className = '', children }) {
  return (
    <div className={className}>
      <p className="text-xs font-semibold text-brand-500">{label}</p>
      <div className="mt-1 min-h-[38px] rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-700">
        {children ?? (value || 'N/A')}
      </div>
    </div>
  );
}

export default Field;
